<template>
    <div class="form-container">
        <Form class="form-contacts" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }" v-if="formVisible">
            <div class="form-in" :class="{'disabled-form' : formDisabled}">
                <TextInput
                    name="name"
                    type="text"
                    :placeholder="formSetUp.inputname"
                    :class="{'error' : errors.name}"
                />
                <TextInput
                    name="phone"
                    type="text"
                    :placeholder="formSetUp.inputphone"
                    v-maska="'+7 (###) ###-##-##'"
                    :class="{'error' : errors.phone}"
                />

                <!-- Turnstile появляется только после нажатия кнопки -->
                <div
                    ref="turnstileContainer"
                    id="turnstile-container"
                    v-show="turnstileVisible"
                    style="margin: 8px 0;"
                ></div>

                <div class="btn-send">
                    <button
                        class="btn btn-submit btn-success"
                        type="submit"
                        :disabled="errors.name || errors.phone"
                    >
                        {{ formSetUp.btn_name }}
                    </button>
                </div>
            </div>
        </Form>

        <div class="successMessage" v-if="!formVisible">
            <h3>{{ formSetUp.form_success_msg }}</h3>
        </div>

        <div class="to-many-requests-msg" v-if="toManySendingMsg">
            <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
            <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
            <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { Form } from "vee-validate";
    import * as Yup from "yup";
    import TextInput from "@/components/forms/TextInput.vue";

    const TURNSTILE_SITE_KEY = '0x4AAAAAADmgcZZb-HUQzPgS';

    export default {
        name: 'FormFields',
        data() {
            return {
                globalLang: window.GlobalLang,
                toManySendingMsg: false,
                phone: '',
                name: '',
                errorMsg: false,
                formVisible: true,
                formDisabled: false,
                utmUrlParams: {},
                turnstileToken: null,
                turnstileWidgetId: null,
                turnstileVisible: false,   // капча скрыта до нажатия кнопки
                pendingSubmit: false,      // ждём токен после показа капчи
            }
        },
        components: {
            TextInput,
            Form,
        },
        computed: mapGetters({
            formSetUp: 'loadFormSetUp',
        }),
        setup() {
            const schema = Yup.object().shape({
                name: Yup.string()
                    .required('Title is required')
                    .matches(/^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/),
                phone: Yup.string()
                    .required('First Name is required')
                    .matches(/^\+7\s?\((700|701|702|703|704|705|706|707|708|709|747|771|775|776|777|778)\)\s?\d{3}-\d{2}-\d{2}$/),
            });
            return { schema };
        },
        mounted() {
            this.loadTurnstileScript();
        },
        beforeUnmount() {
            if (window.turnstile && this.turnstileWidgetId !== null) {
                window.turnstile.remove(this.turnstileWidgetId);
            }
        },
        methods: {
            // Загружаем скрипт один раз при монтировании, но НЕ рендерим виджет
            loadTurnstileScript() {
                if (window.turnstile) return; // уже загружен

                const script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            },

            // Рендерим виджет только при первом нажатии кнопки
            renderTurnstile() {
                const tryRender = () => {
                    if (!window.turnstile || !this.$refs.turnstileContainer) return;

                    // Если виджет уже создан — просто сбрасываем его
                    if (this.turnstileWidgetId !== null) {
                        window.turnstile.reset(this.turnstileWidgetId);
                        return;
                    }

                    this.turnstileWidgetId = window.turnstile.render(this.$refs.turnstileContainer, {
                        sitekey: TURNSTILE_SITE_KEY,
                        theme: 'light',        // белый виджет
                        callback: (token) => {
                            this.turnstileToken = token;
                            // Если пользователь уже нажал кнопку — отправляем форму сразу
                            if (this.pendingSubmit) {
                                this.pendingSubmit = false;
                                this.processSend();
                            }
                        },
                        'expired-callback': () => {
                            this.turnstileToken = null;
                        },
                        'error-callback': () => {
                            this.turnstileToken = null;
                        },
                    });
                };

                // Если скрипт ещё не инициализировался — ждём
                if (!window.turnstile) {
                    const interval = setInterval(() => {
                        if (window.turnstile) {
                            clearInterval(interval);
                            tryRender();
                        }
                    }, 100);
                } else {
                    tryRender();
                }
            },

            onSubmit(values) {
                this.name = values.name;
                this.phone = values.phone;

                // Показываем капчу
                this.turnstileVisible = true;

                this.$nextTick(() => {
                    if (this.turnstileToken) {
                        // Токен уже есть (повторная отправка) — сразу идём дальше
                        this.processSend();
                    } else {
                        // Помечаем что ждём токен, рендерим виджет
                        this.pendingSubmit = true;
                        this.renderTurnstile();
                    }
                });
            },

            processSend() {
                let submissionCounter = parseInt(localStorage.getItem('Benelux_submissionCounter') || '0');
                let lastSubmissionTime = parseInt(localStorage.getItem('Benelux_lastSubmissionTime') || '0');
                const currentMinutes = this.getCurrentMinutes();

                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }

                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    this.resetTurnstile();
                    return;
                }

                this.getQueryParams(submissionCounter, lastSubmissionTime);
            },

            resetTurnstile() {
                if (window.turnstile && this.turnstileWidgetId !== null) {
                    window.turnstile.reset(this.turnstileWidgetId);
                }
                this.turnstileToken = null;
                this.pendingSubmit = false;
            },

            getQueryParams(counter, time) {
                const urlParams = new URLSearchParams(window.location.search);
                for (const [key, value] of urlParams.entries()) {
                    this.utmUrlParams[key] = value;
                }
                this.sendData(counter, time);
            },

            sendData(counter, time) {
                this.formDisabled = true;

                const dataForm = {
                    captcha:     this.turnstileToken,
                    captchaKey:  TURNSTILE_SITE_KEY,
                    leadName: this.name,
                    phone: this.normalizePhone(this.phone),
                    complex: 'Benelux',
                    email: '',
                    advertisingChannel: "199",
                    advertisingChannelCode: "199",
                    advertisingChannelName: "Сайт жилого комплекса",
                    leadChannelCode: 'WEBSITE_REST_PRIVATE_OFFICE',
                    leadChannelName: "Личный кабинет",
                    requestWebsite: 'benelux.bazis.kz',
                    description:
                        "Form on page" +
                        (this.utmUrlParams.utm_source    ? ` | Utm Source: ${this.utmUrlParams.utm_source}`    : '') +
                        (this.utmUrlParams.utm_medium    ? ` | Utm Medium: ${this.utmUrlParams.utm_medium}`    : '') +
                        (this.utmUrlParams.utm_campaign  ? ` | Utm Campaign: ${this.utmUrlParams.utm_campaign}` : '') +
                        (this.utmUrlParams.utm_content   ? ` | Utm Content: ${this.utmUrlParams.utm_content}`  : '') +
                        (this.utmUrlParams.utm_term      ? ` | Utm Term: ${this.utmUrlParams.utm_term}`        : ''),
                    utmSource:   this.utmUrlParams.utm_source   || '',
                    utmMedium:   this.utmUrlParams.utm_medium   || '',
                    utmCampaign: this.utmUrlParams.utm_campaign || '',
                    utmName:     this.utmUrlParams.utm_source   ? 'Сайт жилого комплекса - Benelux' : 'UTM отсутствует - Benelux',
                    utmContent:  this.utmUrlParams.utm_content  || '',
                    utmTerm:     this.utmUrlParams.utm_term     || '',
                    utmCode:     this.generateUniqueUTMCode(),
                };

                this.$store.dispatch('sendFormDataToCRM', dataForm).then((response) => {
                    if (response.status === 200) {
                        this.formVisible = false;
                        counter++;
                        localStorage.setItem('Benelux_submissionCounter', String(counter));
                        localStorage.setItem('Benelux_lastSubmissionTime', String(this.getCurrentMinutes()));
                        window.dataLayer.push({ event: 'form_sent' });
                    } else {
                        this.formDisabled = false;
                        this.resetTurnstile();
                        if (response && response.response && response.response.status === 429) {
                            this.toManySendingMsg = true; // «слишком много заявок»
                        } else {
                            console.warn('Ошибка при отправке формы - обратитесь в Call Center');
                        }
                    }
                });
            },

            normalizePhone(phone) {
                const digits = phone.replace(/\D/g, '');
                if (digits.length !== 11 || !digits.startsWith('7')) return null;
                return `+7 ${digits.slice(1,4)} ${digits.slice(4,7)} ${digits.slice(7,9)} ${digits.slice(9,11)}`;
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            generateUniqueUTMCode() {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                const array = new Uint8Array(10);
                crypto.getRandomValues(array);
                return Array.from(array, b => chars[b % chars.length]).join('');
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form.scss';
    @import '@/styles/components/forms/respond/form-respond.scss';
</style>